module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded-t"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Dedicated to Madeline Mattaini")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "ded0"
  }, [_vm._v("who died of diphtheria in January")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("1932 in her 19th year")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Neil Mattaini who died in an")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("automobile accident in June 1932")]), _vm._v(" "), _c('p', {
    staticClass: "ded0"
  }, [_vm._v("in his 21st year")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360ddc54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003_Dedication.vue
// module id = 63
// module chunks = 0